// extracted by mini-css-extract-plugin
export var image = "j8_c5";